import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore';

import { Location, Region } from 'services/action';
import { Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  coverages: [],
  province: null,
  regency: null,
  district: null,
  village: [],
};

export const FormCoverage = ({ data, onClose, onSuccess }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const [
    { isLoading, coverages, province, regency, district, village },
    setState,
  ] = React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleSubmit = async () => {
    const payload = {
      hub_coverages: coverages,
    };

    const submit = await Dispatch(Location.$updateCoverage(data?.id, payload));

    if (submit?.message === 'success') {
      clearState();
      onSuccess();
    }
  };

  const $handleRemove = (i) => {
    let newCoverage = [...coverages];
    newCoverage.splice(i, 1);

    setState((prevState) => ({
      ...prevState,
      coverages: newCoverage,
    }));

    fetchRegion(district, newCoverage);
  };

  const $handleSelect = (v) => {
    // Check for duplicates if coverages already exist
    const vid = _.map(coverages, 'village_id');

    // Use _.reject to filter out duplicates
    const newX = _.reject([v], function (item) {
      return _.includes(vid, item.village_id);
    });

    let newCoverage = coverages ? [...coverages, ...newX] : [...newX];

    setState((prevState) => ({
      ...prevState,
      coverages: newCoverage,
    }));

    fetchRegion(district, newCoverage);
  };

  const $selectAll = async (e) => {
    const x = [...village];
    let newCoverage = coverages ? [...coverages, ...x] : [...x];

    setState((prevState) => ({
      ...prevState,
      coverages: newCoverage,
    }));

    fetchRegion(district, newCoverage);
  };

  const $removeAll = async (e) => {
    setState((prevState) => ({
      ...prevState,
      coverages: [],
    }));

    fetchRegion(district, []);
  };

  const fetchRegion = async (v, c) => {
    if (!v) return;

    const params = {
      district_id: v?.district_id,
    };

    const req = await Dispatch(Region.$get(params));

    if (req?.message === 'success') {
      const vil = _.map(c, 'village_id');
      const newData = _.difference(_.map(req?.data, 'village_id'), vil);
      // Filter req?.data based on the remaining village_ids
      const filteredData = req?.data.filter((item) =>
        newData.includes(item.village_id)
      );

      setState((prevState) => ({
        ...prevState,
        village: filteredData,
      }));
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      coverages: data?.coverages,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <SkeletonsForm count={1} key={i} />
          ))}
        </div>
      </Modal.Body>
    );
  }

  return (
    <>
      <Modal.Body>
        <div className="row m-0">
          <div className="col-12 row mb-4">
            <div className="col-4">
              <Select.Remote
                required
                label="Pilih Province"
                placeholder=""
                url="/region/province"
                row={(d) => {
                  return {
                    value: d?.province_id,
                    label: `${d?.province_name}`,
                  };
                }}
                onSelected={(v) => {
                  setState((prevState) => ({
                    ...prevState,
                    province: v,
                    regency: null,
                    district: null,
                  }));
                }}
              />
            </div>

            {province && (
              <div className="col-4">
                <Select.Remote
                  required
                  label="Pilih Kota/Kabupaten"
                  placeholder=""
                  url="/region/regency"
                  params={
                    province && {
                      province_id: province?.province_id,
                    }
                  }
                  row={(d) => {
                    return {
                      value: d?.regency_id,
                      label: `${d?.regency_name}`,
                    };
                  }}
                  onSelected={(v) => {
                    setState((prevState) => ({
                      ...prevState,
                      regency: v,
                      district: null,
                      village: [],
                    }));
                  }}
                  keys={province?.province_id}
                  errors={StateForm?.errors?.village_id}
                />
              </div>
            )}

            {regency && (
              <div className="col-4">
                <Select.Remote
                  required
                  label="Pilih Kecamatan"
                  placeholder=""
                  url="/region/district"
                  params={
                    regency && {
                      regency_id: regency?.regency_id,
                    }
                  }
                  row={(d) => {
                    return {
                      value: d?.district_id,
                      label: `${d?.district_name}`,
                    };
                  }}
                  onSelected={(v) => {
                    setState((prevState) => ({
                      ...prevState,
                      district: v,
                    }));
                    fetchRegion(v, coverages);
                  }}
                  keys={regency?.regency_id}
                  errors={StateForm?.errors?.village_id}
                />
              </div>
            )}
          </div>
          <div className="col-12 col-md-6">
            <div className="hr-text hr-text-left mb-3 mt-md-3 mt-3">
              Kelurahan
            </div>
            <div className="table-responsive bg-white">
              <table
                width="100%"
                className="table table-hover table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td style={{ width: '5%' }}>No</td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Provinsi
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kota/Kabupaten
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kecamatan
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kelurahan
                    </td>
                    {village?.length > 0 && (
                      <td
                        style={{
                          whiteSpace: 'initial',
                          textAlign: 'center',
                        }}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-top`}>Pilih Semua</Tooltip>
                          }
                        >
                          <div
                            onClick={() => $selectAll()}
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            <Fi.FiCheckSquare color="green" size={15} />
                          </div>
                        </OverlayTrigger>
                      </td>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {village?.map((d, i) => (
                    <tr key={i} onClick={() => $handleSelect(d)}>
                      <td>{i + 1}</td>
                      <td>{d?.province_name}</td>
                      <td>{d?.regency_name}</td>
                      <td>{d?.district_name}</td>
                      <td>{d?.village_name}</td>
                      <td>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id={`tooltip-top`}>Pilih</Tooltip>}
                        >
                          <div
                            onClick={() => $handleSelect(d)}
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            <Fi.FiCheck color="green" size={15} />
                          </div>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="hr-text hr-text-left mb-3 mt-md-3 mt-3">
              Coverage
            </div>
            <div className="table-responsive bg-white">
              <table
                width="100%"
                className="table table-hover table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td style={{ width: '5%' }}>No</td>
                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Provinsi
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kota/Kabupaten
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kecamatan
                    </td>

                    <td
                      style={{
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                    >
                      Kelurahan
                    </td>
                    {coverages?.length > 0 && (
                      <td
                        style={{
                          whiteSpace: 'initial',
                          textAlign: 'center',
                        }}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id={`tooltip-top`}>Hapus Semua</Tooltip>
                          }
                        >
                          <div
                            onClick={() => $removeAll()}
                            style={{
                              cursor: 'pointer',
                            }}
                          >
                            <Fi.FiTrash2 color="red" size={15} />
                          </div>
                        </OverlayTrigger>
                      </td>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {coverages?.map((d, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{d?.province_name}</td>
                      <td>{d?.regency_name}</td>
                      <td>{d?.district_name}</td>
                      <td>{d?.village_name}</td>
                      <td
                        style={{
                          whiteSpace: 'initial',
                          textAlign: 'center',
                        }}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
                        >
                          <div onClick={() => $handleRemove(i)}>
                            <Fi.FiTrash2 color="red" />
                          </div>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className="btn btn-light w-100"
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
